import de from "@/locales/de.json";
import en from "@/locales/en.json";

export const locales = {
  en: { default: en },
  de: { default: de },
} as const;

export default locales;
